<content-panel>
  <panel-header [heading]="heading">
    @if (shouldShowDeleteButton) {
      <button mat-icon-button matTooltip="Delete" (click)="confirmDelete()">
        <mat-icon>delete</mat-icon>
      </button>
    }
    @if (shouldShowResetStatusButton) {
      <button
        mat-icon-button
        matTooltip="Reset Status"
        (click)="confirmResetStatus()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    }
    @if (shouldShowConvertV3ToV2Button) {
      <button
        mat-icon-button
        matTooltip="Convert V3 to V2"
        (click)="confirmConvertV3ToV2()"
      >
        <mat-icon>swap_horiz</mat-icon>
      </button>
    }
    @if (shouldShowConvertV2ToV3Button) {
      <button
        mat-icon-button
        matTooltip="Convert V2 to V3"
        (click)="confirmConvertV2ToV3()"
      >
        <mat-icon>swap_horiz</mat-icon>
      </button>
    }
    @if (form.touched) {
      <button mat-icon-button matTooltip="Close" (click)="unsavedChanges()">
        <mat-icon>close</mat-icon>
      </button>
      <button
        mat-icon-button
        matTooltip="Save"
        (click)="saveChanges()"
        [disabled]="shouldSaveBeDisabled"
      >
        <mat-icon>save</mat-icon>
      </button>
    } @else {
      <button mat-icon-button matTooltip="Close" (click)="closePanel()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </panel-header>
  <panel-body class="detail-view-container">
    <div class="content">
      @if (formSaveBanner) {
        <div class="form-save-banner">
          {{ this.formSaveBanner }}
        </div>
      }
      <form [formGroup]="form">
        @for (group of dynamicForm?.formGroups; track group) {
          @if (!group.hidden) {
            <lib-dynamic-form-group [group]="group"> </lib-dynamic-form-group>
          }
        }
      </form>
    </div>
  </panel-body>
</content-panel>
